import { useTranslation } from 'react-i18next'
import { Alert, AlertDescription, Button } from '@agion/ui'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import type { ImageDeviation } from './infra_image.service'

interface Props {
  deviations: ImageDeviation[]
  onRefresh: () => void
  isRefreshing: boolean
}

export function DeviationsBanner({ deviations, onRefresh, isRefreshing }: Props) {
  const { t } = useTranslation(['pages'])

  if (deviations.length === 0) return null

  const byType = deviations.reduce(
    (acc, d) => {
      acc[d.deviationType] = (acc[d.deviationType] || 0) + 1
      return acc
    },
    {} as Record<string, number>,
  )

  const parts: string[] = []
  if (byType['missing']) parts.push(`${byType['missing']} ${t('pages:images.deviations.missing', 'missing')}`)
  if (byType['outdated']) parts.push(`${byType['outdated']} ${t('pages:images.deviations.outdated', 'outdated')}`)
  if (byType['deprecated']) parts.push(`${byType['deprecated']} ${t('pages:images.deviations.deprecated', 'deprecated')}`)

  return (
    <Alert variant="warning">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AlertTriangle size={16} />
          <AlertDescription>
            {t('pages:images.deviations.title', 'Image deviations detected')}: {parts.join(', ')}
          </AlertDescription>
        </div>
        <Button variant="ghost" size="sm" onClick={onRefresh} disabled={isRefreshing}>
          <RefreshCw size={14} className={isRefreshing ? 'animate-spin' : ''} />
        </Button>
      </div>
    </Alert>
  )
}
